import { Component, OnInit, Input } from '@angular/core';
import { AvailabilityService } from './availability.service';
import { ValueIsProperty, Field } from '../../../Models';
import { ValueTextItem } from '../../../Models/ModuleDefinitions/ValueTextItem';
import { ValueIsPropertyOperators } from '../../../../../../Constants/ValueIsPropertyOperators';
import { FormFlowFieldTypes } from '../../../../../../Constants/FormFlowFieldTypes';
import { ListParameters } from '../../../../../../Constants/ListParameters';
import { ListSelectTypes } from '../../../../../../Constants/ListSelectTypes';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'aw-availability-condition',
    templateUrl: './availability-condition.component.html',
    styleUrls: ['./availability-condition.component.less'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatSelect, MatOption, MatError, MatCheckbox, MatButton, MatIcon]
})
export class AvailabilityConditionComponent implements OnInit {
    @Input() item: ValueIsProperty;
    @Input() index: number;
    field: Field;
    selectedFieldType: string;
    isMultiple: boolean = false;
    isReadOnly: boolean = false;
    identifiers: ValueTextItem[];
    valueOptions?: ValueTextItem[];    

    constructor(
        private availabilityService: AvailabilityService
    ) { }

    ngOnInit(): void {
        this.field = this.availabilityService.conditionFields.filter(field => field.FieldId === this.item.PropertyName)[0];
        this.calculateIdentifiers();
        this.calculateIsMultiple();

        if (this.field) {
            this.selectedFieldType = this.field.FieldType;
        } else {
            this.selectedFieldType = FormFlowFieldTypes.Text;
            if (this.item.PropertyName) {
                this.isReadOnly = true;
            }
        }
        
        this.configureValueControl();
    }

    onDeleteButtonClick(): void {
        this.availabilityService.deleteCondition(this.index);
    }

    calculateIsMultiple(): void {
        if (this.field &&
            this.field.FieldType === FormFlowFieldTypes.List &&
            this.field.ListType != ListSelectTypes.SingleRadios &&
            (this.item.ValueIs.Identifier === ValueIsPropertyOperators.OneOf || this.item.ValueIs.Identifier === ValueIsPropertyOperators.NotOneOf)) {
            this.isMultiple = true;
        } else {
            this.isMultiple = false;
        }
    }

    calculateIdentifiers(): void {
        let fieldType: string = this.field ? this.field.FieldType : FormFlowFieldTypes.Text;
        switch (fieldType) {
            case FormFlowFieldTypes.List:
                this.identifiers = [
                    { Value: ValueIsPropertyOperators.CollectionEmpty, Text: "Collection Empty" },
                    { Value: ValueIsPropertyOperators.CollectionNotEmpty, Text: "Collection Not Empty" },
                    { Value: ValueIsPropertyOperators.ValueString, Text: "Equals" },
                    { Value: ValueIsPropertyOperators.OneOf, Text: "Is One Of" },
                    { Value: ValueIsPropertyOperators.NotValueString, Text: "Doesn't Equal" },
                    { Value: ValueIsPropertyOperators.NotOneOf, Text: "Is Not One Of" }
                ];
                break;
            case FormFlowFieldTypes.Text:
                this.identifiers = [
                    { Value: ValueIsPropertyOperators.Undefined, Text: "Undefined" },
                    { Value: ValueIsPropertyOperators.Defined, Text: "Defined" },
                    { Value: ValueIsPropertyOperators.ValueString, Text: "Equals" },
                    { Value: ValueIsPropertyOperators.NotValueString, Text: "Doesn't Equal" }
                ];
                break;
            case FormFlowFieldTypes.Checkbox:
                this.identifiers = [
                    { Value: ValueIsPropertyOperators.False, Text: "Is False" },
                    { Value: ValueIsPropertyOperators.True, Text: "Is True" },
                    { Value: ValueIsPropertyOperators.Undefined, Text: "Undefined" },
                    { Value: ValueIsPropertyOperators.Defined, Text: "Defined" }
                ];
                break;
            default:
                this.identifiers = [];
                break;
        }
    }    

    configureValueControl(): void {
        switch (this.selectedFieldType) {
            case FormFlowFieldTypes.List:
                if (this.field.ListParams[ListParameters.ListAlias] === undefined) {
                    this.selectedFieldType = FormFlowFieldTypes.Text;
                } else {
                    this.availabilityService.getListItems(this.field.ListParams[ListParameters.ListAlias])
                        .subscribe(result => {
                            this.valueOptions = result;
                        });
                }
                break;
            default:
                break;
        }
    }

    conditionFieldChanged(): void {
        this.field = this.availabilityService.conditionFields.filter(field => field.FieldId === this.item.PropertyName)[0];
        this.selectedFieldType = this.field.FieldType;
        this.calculateIdentifiers();
        this.calculateIsMultiple();
        this.configureValueControl();
        this.availabilityService.canSave = true;
    }

    identifierFieldChanged(): void {
        this.calculateIsMultiple();
        this.configureValueControl();
        this.availabilityService.canSave = true;
    }

    valueFieldChanged(): void {
        this.availabilityService.canSave = true;
    }

    prettifyLabel(lbl: string): string {
        return this.availabilityService.prettifyLabel(lbl);
    }
}
